import { ButtonProps, useDisclosure } from '@chakra-ui/react';
import React from 'react';
import { MButton } from '../../../components/Monetize';
import { useFlags } from '../../../services/launchDarkly';
import { GatewayAccountLinkModal } from './GatewayAccountLinkModal';

interface GatewayAccountLinkButtonProps {
  accountId: string;
  paymentGatewayId: string;
  buttonProps?: Pick<ButtonProps, 'variant' | 'size' | 'mt'>;
}

export const GatewayAccountLinkButton: React.FC<
  GatewayAccountLinkButtonProps
> = ({ accountId, paymentGatewayId, buttonProps = {} }) => {
  const { open: isOpen, onOpen, onClose } = useDisclosure();
  const { enableGatewayAccountLink } = useFlags();

  if (!enableGatewayAccountLink) {
    return null;
  }
  return (
    <>
      <MButton onClick={onOpen} {...buttonProps}>
        Link Payment Gateway Account
      </MButton>

      {isOpen && (
        <GatewayAccountLinkModal
          onClose={onClose}
          accountId={accountId}
          paymentGatewayId={paymentGatewayId}
        />
      )}
    </>
  );
};
